(function () {
  const DRAWER_COUNTDOWN_ID = 'cart-countdown-upcart-drawer';
  const DRAWER_STORAGE_KEY = 'roosty_cart_countdown_end_upcart_drawer_465';

  function getSharedStorageKey(durationSeconds) {
    return `roosty_cart_countdown_end_shared_${durationSeconds}`;
  }

  function formatTime(totalSeconds) {
    const m = Math.floor(totalSeconds / 60)
      .toString()
      .padStart(2, '0');
    const s = (totalSeconds % 60).toString().padStart(2, '0');
    return `00:${m}:${s}`;
  }

  function initCountdown(root) {
    if (root.dataset.countdownInitialized === 'true') return;

    const durationSeconds = Math.max(
      1,
      parseInt(root.getAttribute('data-duration-seconds'), 10) || 465
    );
    const storageKey = root.getAttribute('data-storage-key') || DRAWER_STORAGE_KEY;
    const sharedStorageKey = getSharedStorageKey(durationSeconds);
    const storageKeys = [sharedStorageKey, storageKey];

    const timerId = root.querySelector('[id^="cart-countdown-timer"]');
    if (!timerId) return;
    root.dataset.countdownInitialized = 'true';

    function getOrSetEndTime() {
      let endTime = null;

      for (const key of storageKeys) {
        const value = sessionStorage.getItem(key);
        if (value) {
          endTime = parseInt(value, 10);
          if (!Number.isNaN(endTime)) break;
        }
      }

      if (!endTime) {
        endTime = Date.now() + durationSeconds * 1000;
      }

      storageKeys.forEach((key) => sessionStorage.setItem(key, endTime));
      return endTime;
    }

    function resetEndTime() {
      const endTime = Date.now() + durationSeconds * 1000;
      storageKeys.forEach((key) => sessionStorage.setItem(key, endTime));
      return endTime;
    }

    let endTime = getOrSetEndTime();
    const remainingOnLoad = Math.max(0, Math.round((endTime - Date.now()) / 1000));
    timerId.textContent = formatTime(remainingOnLoad);

    setInterval(() => {
      const remaining = Math.round((endTime - Date.now()) / 1000);

      if (remaining <= 0) {
        endTime = resetEndTime();
        timerId.textContent = formatTime(durationSeconds);
      } else {
        timerId.textContent = formatTime(remaining);
      }
    }, 1000);
  }

  function startCountdowns() {
    document.querySelectorAll('[data-cart-countdown]').forEach(initCountdown);
  }

  function ensureDrawerCountdown() {
    const checkoutButton = document.querySelector('.upcart-checkout-button');
    if (!checkoutButton) return;
    if (document.getElementById(DRAWER_COUNTDOWN_ID)) return;
    const sourceCountdown = document.querySelector(
      '[data-cart-countdown]:not(#' + DRAWER_COUNTDOWN_ID + ')'
    );
    const drawerDuration = Math.max(
      1,
      parseInt(sourceCountdown?.getAttribute('data-duration-seconds') || '465', 10) || 465
    );

    const countdownNode = document.createElement('div');
    countdownNode.className = 'cart-countdown cart-countdown--drawer';
    countdownNode.id = DRAWER_COUNTDOWN_ID;
    countdownNode.setAttribute('data-cart-countdown', '');
    countdownNode.setAttribute('data-duration-seconds', String(drawerDuration));
    countdownNode.setAttribute(
      'data-storage-key',
      sourceCountdown?.getAttribute('data-storage-key') || DRAWER_STORAGE_KEY
    );
    countdownNode.setAttribute('aria-live', 'polite');
    countdownNode.style.cssText =
      '--cc-text: #3a3a3a;' +
      '--cc-bg: #ffffff;' +
      '--cc-border-w: 2px;' +
      '--cc-border-style: dashed;' +
      '--cc-radius: 6px;' +
      '--cc-py: 8px;' +
      '--cc-px: 14px;' +
      '--cc-mv: 12px;' +
      '--cc-max-w: 420px;' +
      '--cc-gap: 8px;' +
      '--cc-fs-text: 14px;' +
      '--cc-fs-timer: 16px;' +
      '--cc-justify: center;';

    countdownNode.innerHTML =
      '<span class="cart-countdown__text">Your Products Are Reserved For</span>' +
      `<span class="cart-countdown__timer" id="cart-countdown-timer-upcart-drawer">${formatTime(
        drawerDuration
      )}</span>` +
      '<span class="cart-countdown__text">Minutes!</span>';

    checkoutButton.insertAdjacentElement('afterend', countdownNode);
    initCountdown(countdownNode);
  }

  function start() {
    startCountdowns();
    ensureDrawerCountdown();
  }

  document.addEventListener('DOMContentLoaded', start);
  setInterval(ensureDrawerCountdown, 1000);
})();
